module.exports = __webpack_public_path__ + "static/fede-1-7c40b611ecca3fc865c9e72cb0fd9438.png";